import React from 'react';
import { Card, CardBody } from '@material-tailwind/react';
import { Bar, BarChart, CartesianGrid, Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import LoadingPanel from './LoadingPanel';
import OverviewStatsCards from './OverviewStatsCards';
import MonthlyInvoiceAmountReport from './MonthlyInvoiceAmountReport';

const MonthlyInvoiceOverviewReport = ({
  summaryLoading,
  summary,
  statusChart,
  amountChart,
  paymentChart,
  statusColors,
  paymentColors,
  formatMoney
}) => {
  if (summaryLoading) {
    return <LoadingPanel label="Loading overview..." />;
  }

  return (
    <div className="space-y-4">
      <OverviewStatsCards summary={summary} />
      <div className="grid gap-4 xl:grid-cols-2">
        <Card className="shadow-lg">
          <CardBody className="p-0">
            <div className="border-b border-slate-200 px-5 py-4">
              <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Invoice status chart</div>
            </div>
            <div className="h-[320px] px-3 py-4">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={statusChart}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                  <XAxis dataKey="month_label" tickMargin={10} />
                  <YAxis allowDecimals={false} />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="DRAFT" stackId="invoice-status" fill={statusColors.DRAFT || '#f59e0b'} />
                  <Bar dataKey="SENT" stackId="invoice-status" fill={statusColors.SENT || '#0ea5e9'} />
                  <Bar dataKey="PAID" stackId="invoice-status" fill={statusColors.PAID || '#10b981'} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </CardBody>
        </Card>
      </div>
      <div className="grid gap-4 xl:grid-cols-2">
        <MonthlyInvoiceAmountReport
          summaryLoading={summaryLoading}
          amountChart={amountChart}
          statusColors={statusColors}
          formatMoney={formatMoney}
        />
        <Card className="shadow-lg">
          <CardBody className="p-0">
            <div className="border-b border-slate-200 px-5 py-4">
              <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Payment chart</div>
            </div>
            <div className="h-[320px] px-3 py-4">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={paymentChart} dataKey="count" nameKey="name" innerRadius={80} outerRadius={115} paddingAngle={3}>
                    {paymentChart.map((entry) => (
                      <Cell key={entry.bucket} fill={paymentColors[entry.bucket] || '#64748b'} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default MonthlyInvoiceOverviewReport;
